const config = {
	'apiBaseURL': 'https://beta.11zz.club/api/v1',
	'persistentStorageName': 'wind-admin-store',
	'debugApiError': false,
	'testing': false,
	'testingBaseUrl': 'http://localhost:6000'
}

export default config